module.exports = __webpack_public_path__ + "static/media/plink-logo-v2.c275b5d2.svg";